import { Box, Typography } from '@mui/material'
import { jwtDecode } from 'jwt-decode'
import { getToken } from 'shared/utils/auth'

interface DecodedToken {
    impersonatedBy?: string
    nickname?: string
    firstName?: string
    lastName?: string
}

export function ImpersonationBanner() {
    const token = getToken()
    if (!token) return null

    let decoded: DecodedToken
    try {
        decoded = jwtDecode<DecodedToken>(token)
    } catch {
        return null
    }

    if (!decoded.impersonatedBy) return null

    return (
        <Box
            data-testid="impersonation-banner"
            sx={{
                backgroundColor: '#ff9800',
                color: '#000',
                px: 2,
                py: 0.5,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexShrink: 0,
            }}
        >
            <Typography variant="body2" fontWeight="bold">
                You are viewing this portal as{' '}
                {decoded.nickname ?? decoded.firstName} {decoded.lastName}
            </Typography>
        </Box>
    )
}
